<template>
  <div class="proposal-detail">
    <gov-header />
    <section v-if="$store.daoParameters !== null && propData !== null && ($store.wallet === null || $store.kDAOCheckpointCount !== null)" class="section is-paddingless proposals-and-timelocks">
      <div class="columns is-centered">
        <div class="column is-three-fifths-desktop is-four-fifths-tablet">
          <proposal
            :poll-data="propData.poll"
            :prop-number="$route.params.propNumber"
            :read-only="true"
            :show-outcome="true"
          >
            <template v-slot:extra-tags>
              <proposal-outcome :prop-data="propData" />
            </template>
          </proposal>
        </div>
      </div>
    </section>
    <section v-else>
      <div class="columns is-centered">
        <div class="column is-three-fifths-desktop is-four-fifths-tablet">
          <div class="box info-box loader-box content">
            <div class="loader-wrapper">
              <div class="loader is-large is-primary"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import GovHeader from "@/components/GovHeader";
import Proposal from "@/components/Proposal";
import ProposalOutcome from "@/components/ProposalOutcome";

export default {
  name: 'ProposalDetail',
  components: {ProposalOutcome, Proposal, GovHeader},
  async mounted(){
    if (!this.$route.params.propNumber || this.$route.params.propNumber < 1){
      this.$router.push({name: 'Index'})
    }

    if (this.$store.daoParameters === null){
      this.$eventBus.$on('dao-info-loaded', this.fetchPropData)
    } else {
      await this.fetchPropData()
    }
  },
  data(){
    return {
      networkLoading: false,
      propData: null,
    }
  },
  methods:{
    async fetchPropData(){
      const daoContract = await this.$store.tezosToolkit.wallet.at(this.$store.contracts.DAO)
      const daoStorage = await daoContract.storage()
      const propData = await daoStorage.outcomes.get((this.$route.params.propNumber - 1).toString())

      if (propData === undefined) {
        await this.$router.push({name: 'Index'})
      } else {
        this.propData = propData
      }
    }
  },
  computed: {

  }
}
</script>

<style lang="scss">
@import '../assets/sass/globals';
.proposal-detail{
  .loader-box{
    padding: 4rem;
  }
}

</style>
